let productThumbSlider = null;
let productMainSlider = null;

function initProductSlider() {
  if (productThumbSlider) {
    productThumbSlider.destroy(true, true);
    productThumbSlider = null;
  }

  if (productMainSlider) {
    productMainSlider.destroy(true, true);
    productMainSlider = null;
  }
  if (!document.querySelector(".product-main-slider")) return;

  productThumbSlider = new Swiper(".product-thumb-slider", {
    direction: "vertical",
    slidesPerView: 3,
    spaceBetween: 15,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    observer: true,
    observeParents: true,
    breakpoints: {
      0: {
        direction: "horizontal",
        slidesPerView: 3
      },
      992: {
        direction: "vertical"
      }
    }
  });

  productMainSlider = new Swiper(".product-main-slider", {
    spaceBetween: 10,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    thumbs: {
      swiper: productThumbSlider
    }
  });
}
document.addEventListener("DOMContentLoaded", function () {
  initProductSlider();
});

document.addEventListener("shopify:section:load", function (event) {
  initProductSlider();
});

document.addEventListener("shopify:block:select", function () {
  initProductSlider();
});
